// src/services/aiAnalysisService.ts - FRONTEND (SIN DATABASE)

import { API_ENDPOINTS, apiPost } from '../config/api';

interface AISuggestion {
  type: 'similar_ticket' | 'knowledge_article' | 'quick_tip';
  title: string;
  content: string;
  relevance: number;
  ticketId?: string;
  articleId?: string;
}

export const aiAnalysisService = {
  async analyzeDescription(description: string): Promise<AISuggestion[]> {
    if (!description || description.length < 20) {
      return [];
    }

    try {
      console.log('🤖 [IA Frontend] Enviando a backend:', description.substring(0, 50) + '...');
      console.log('🔍 [AI] Endpoint:', API_ENDPOINTS.AI_ANALYZE_DESCRIPTION);
      // Solo hace llamada HTTP al backend
      const data = await apiPost(API_ENDPOINTS.AI_ANALYZE_DESCRIPTION, { description });
      
      console.log('✅ [IA Frontend] Respuesta:', data);
      
      if (data.success && data.suggestions) {
        return data.suggestions;
      }
      
      return [];
    } catch (error) {
      console.error('❌ [IA Frontend] Error llamando backend:', error);
      console.log('📦 [IA Frontend] Usando fallback local');
      
      // Fallback local si backend no responde
      return this.generateLocalSuggestions(description);
    }
  },

  // Sugerencias locales como fallback
  generateLocalSuggestions(description: string): AISuggestion[] {
    const tips: AISuggestion[] = [];
    const lowerDesc = description.toLowerCase();

    const tipDatabase = [
      {
        keywords: ['válvula', 'valve', 'ventil'],
        tip: {
          type: 'quick_tip' as const,
          title: 'Tip: Verificación de válvulas',
          content: 'Verifica: 1) Presión del sistema, 2) Limpieza de filtros, 3) Conexiones eléctricas.',
          relevance: 0.8
        }
      },
      {
        keywords: ['motor', 'engine'],
        tip: {
          type: 'quick_tip' as const,
          title: 'Tip: Diagnóstico de motor',
          content: 'Revisa: 1) Nivel de aceite, 2) Filtros de aire, 3) Conexiones de sensores.',
          relevance: 0.8
        }
      },
      {
        keywords: ['eléctrico', 'electrical', 'cable'],
        tip: {
          type: 'quick_tip' as const,
          title: 'Tip: Problemas eléctricos',
          content: 'Seguridad primero. Verifica: 1) Fusibles, 2) Conexiones, 3) Cables dañados.',
          relevance: 0.8
        }
      },
      {
        keywords: ['temperatura', 'temperature', 'calor'],
        tip: {
          type: 'quick_tip' as const,
          title: 'Tip: Problemas de temperatura',
          content: 'Verifica: 1) Refrigeración, 2) Termostato, 3) Nivel de refrigerante.',
          relevance: 0.9
        }
      },
      {
        keywords: ['fuga', 'leak', 'aceite'],
        tip: {
          type: 'quick_tip' as const,
          title: 'Tip: Fugas',
          content: 'Localiza: 1) Limpia área, 2) Observa operación, 3) Identifica fluido.',
          relevance: 0.8
        }
      }
    ];

    for (const item of tipDatabase) {
      if (item.keywords.some(keyword => lowerDesc.includes(keyword))) {
        tips.push(item.tip);
      }
    }

    if (tips.length === 0) {
      tips.push({
        type: 'quick_tip',
        title: 'Tip: Información útil',
        content: 'Incluye: 1) Códigos de error, 2) Cuándo comenzó, 3) Condiciones, 4) Fotos.',
        relevance: 0.5
      });
    }

    return tips.slice(0, 5);
  }
};